import { Gear } from '@phosphor-icons/react'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import api from '@/api'
import ElationEHRLogo from '@/assets/logos/elation-ehr-logo.jpg'

import { IntegrationCard } from '../IntegrationCard'

export const ElationIntegrationComponent = () => {
  const history = useHistory()
  const [hasCredentials, setHasCredentials] = useState(false)

  useEffect(() => {
    const fetchCredentials = async () => {
      const credentials = await api.getElationCredentials()
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (credentials.username) {
        setHasCredentials(true)
      }
    }

    void fetchCredentials()
  }, [])

  return (
    <IntegrationCard.Root>
      <IntegrationCard.Header>
        <div className="flex items-center">
          <IntegrationCard.Image src={ElationEHRLogo} />
          <IntegrationCard.Title>Elation EHR</IntegrationCard.Title>
        </div>
      </IntegrationCard.Header>
      <IntegrationCard.Content>
        <IntegrationCard.Description>
          Integrate data and files to Elation EHR
        </IntegrationCard.Description>
      </IntegrationCard.Content>
      <IntegrationCard.Footer>
        <IntegrationCard.Button
          disabled={!hasCredentials}
          onClick={() => history.push('/settings/elation')}
        >
          <Gear className="text-lg" /> Settings
        </IntegrationCard.Button>
      </IntegrationCard.Footer>
    </IntegrationCard.Root>
  )
}
